import { sortBy, uniqBy } from 'lodash-es';

import { reportGroupsStore } from '@stores/dictionaryStores/reportGroupsStore/reportGroupsStore';
import type { ReportPeriodDto } from '@src/api';
import type { ReportPeriodDtoDefId } from '@stores/dictionaryStores/reportPeriodsStore';

type ReportPeriodWithChildrenDtoDefId = ReportPeriodDto & {
  children?: ReportPeriodWithChildrenDtoDefId[];
  key: string;
  title: string;
};

// Группировка по report_group
export const toTreeView = (reportPeriods: ReportPeriodDtoDefId[]): ReportPeriodWithChildrenDtoDefId[] => {
  const { reportGroups } = reportGroupsStore;

  return sortBy(
    uniqBy(
      reportPeriods.filter((item) => !!item.reportGroupCode),
      'reportGroupCode',
    ).map((report) => {
      const group = reportGroups.find((item) => item.code === report.reportGroupCode);

      return {
        ...report,
        key: report.reportGroupCode ?? '',
        title: group ? `${group.code} - ${group.name}` : '',
        count:
          reportPeriods.filter((reportPeriod) => reportPeriod.reportGroupCode === report.reportGroupCode).length ?? '',
      };
    }),
    'title',
  );
};
